// import React, { useState, useEffect } from 'react'
// import "../../scss/table.scss";
// import axios from 'axios';
// import moment from 'moment';
// import ControlDate from './ControlDate';
// import Information from './Information';
// import Pagination from './Pagination';
// import Detail from './Detail';
// import Error from './Error';
// import { useNavigate } from 'react-router-dom';
// import Footer from '../Footer';
// import NavbarHome from '../Navbar/NavbarHome';

// const Report = () => {
//     // const [outletName, setOutletName] = useState("")
//     const [information, setInformation] = useState({});
//     const [orders, setOrders] = useState([]);
//     const [error, setError] = useState(true);
//     // const [totalCount, setTotalCount] = useState("");
//     const [firstDate, setFirstDate] = useState("")
//     const [secondDate, setSecondDate] = useState("")
//     const [startDate, setStartDate] = useState(new Date());
//     const [endDate, setEndDate] = useState(new Date());
//     const [maxPageLength, setMaxPageLength] = useState();
//     const [pageLength, setPageLength] = useState([]);
//     const [categories, setCategories] = useState({})
//     const [categoryVoid, setCategorieVoid] = useState({})
//     const [token, setToken] = useState("")
//     // const [Outlet, setOutlet] = useState("");
//     const [selectedOutlet, setSelectedOutlet] = useState("");

//     let url = process.env.REACT_APP_BASE_URL;
//     let navigate = useNavigate();

//     useEffect(() => {
//         setToken(localStorage.getItem('token'))
//     }, [])

//     useEffect(() => {
//         let tokenCheck = localStorage.getItem("token");
//         let typeCheck = localStorage.getItem("type")

//         if (tokenCheck === null && !typeCheck) {
//             navigate("/");
//         } else {
//             setToken(localStorage.getItem("token"));
//         }
//     }, [navigate]);

//     useEffect(() => {
//         let initialDate = startDate
//         let date = moment(initialDate).format();
//         let firstDate = date.toString().substring(0, 10)
//         setFirstDate(firstDate)

//         let lastDate = endDate
//         let dates = moment(lastDate).format();
//         let secondDate = dates.toString().substring(0, 10)
//         setSecondDate(secondDate);

//     }, [startDate, endDate])

//     // useEffect(() => {
//     //     let totalCount = 0;
//     //     orders.map((element) => (
//     //         element.items.map((item) => {
//     //             totalCount = totalCount + 1;
//     //         })
//     //     ))
//     //     setTotalCount(totalCount)
//     // }, [orders])

//     useEffect(() => {
//         let arrayLength = [];

//         for (let i = 1; i < maxPageLength + 1; i++) {
//             arrayLength.push(i)
//         }
//         setPageLength(arrayLength)
//     }, [maxPageLength])

//     const handleGenerateReport = () => {
//         axios.post(`${url}/report`, {
//             "start_date": firstDate,
//             "end_date": secondDate,
//             "outlet_name": selectedOutlet,
//             "page_no": 1,
//             "token": token
//         })
//             .then((response) => {
//                 console.log(response)
//                 setInformation(response.data)
//                 setMaxPageLength(response.data.maxPage_Length)
//                 setOrders(response.data.orders)
//                 setError(false)
//             })
//             .catch((error) => {
//                 setError(true)
//             })
//     }
//     const handleNumber = (page) => {
//         axios.post(`${url}/report`, {
//             "start_date": firstDate,
//             "end_date": secondDate,
//             "outlet_name": selectedOutlet,
//             "page_no": page,
//             "token": token
//         })
//             .then((response) => {
//                 setOrders(response.data.orders)
//             })
//             .catch((error) => {
//                 console.log(error)
//             })

//     }
//     const handleSidebar = () => {
//         axios.post(`${url}/itemstats`, {
//             "start_date": firstDate,
//             "end_date": secondDate,
//             "outlet_name": selectedOutlet,
//             "token": token
//         })
//             .then((response) => {
//                 console.log(response.data)
//                 setCategories(response.data.Completed)
//                 setCategorieVoid(response.data.Void)
//             })
//             .catch((error) => {
//                 console.log(error.response.data)
//             })
//     }

//     // const handleChange = (e) => {
//     //     setOutletName(e)
//     // }

//     return (
//         <div>
//             <NavbarHome />
//             <div className='info-side-bar'>
//                 <div className='info-bar-report'>
//                     <div className='information-report'>
//                         <Detail information={information} />
//                     </div>
//                 </div>
//                 <div className='info-report-container'>
//                     <ControlDate
//                         startDate={startDate}
//                         setStartDate={setStartDate}
//                         endDate={endDate}
//                         setEndDate={setEndDate}
//                         selectedOutlet={selectedOutlet}
//                         setSelectedOutlet={setSelectedOutlet}
//                         handleGenerateReport={handleGenerateReport}
//                         handleSidebar={handleSidebar}
//                         categories={categories}
//                         categoryVoid={categoryVoid}
//                     />
//                     <div className='information-report-responsive'>
//                         <Detail information={information} />
//                     </div>
//                     {error ? <Error /> :
//                         <div className='report'>
//                             {/* <div className='show-outlet-name'>
//                                 <h4>{outletName}</h4>
//                             </div> */}
//                             <Information orders={orders} information={information} />
//                         </div>
//                     }
//                     <Pagination pageLength={pageLength} handleNumber={handleNumber} />
//                 </div>
//             </div>
//             <Footer />
//         </div>
//     )
// }

// export default Report















import React, { useState, useEffect } from 'react'
import axios from 'axios';
import { IoFastFoodOutline, IoFastFood, IoPeopleOutline } from "react-icons/io5";
import { FcClock } from "react-icons/fc";
import { RiNumbersLine } from "react-icons/ri";
import { toast } from 'react-toastify';
import Navbar from '../Navbar';
import Footer from '../Footer';
import PageStatus from './../PageStatus/PageStatus';
import KitchenSummaryDetails from './../Home/Kitchen/Report/KitchenSummaryDetails';
import { convertTime } from '../../utils/timeUtils';
import KitchenSummarySidebar from '../Home/Kitchen/Report/KitchenSummarySidebar';
import KitchenReportTable from '../Home/Kitchen/Report/KitchenReportTable';
import { KitchenReportPagination } from '../Home/Kitchen/Report/KitchenReportPagination';
import KitchenOrderListView from '../Home/Kitchen/Report/KitchenOrderListView';
import OutletSearch from '../SelectSearch/OutletSearch';

const StatCard = ({ icon: Icon, label, value, iconClass = "" }) => (
    <div className="flex items-center gap-2 bg-gray-50 rounded-lg p-2 border border-gray-100">
        <div className={`text-xl shrink-0 ${iconClass}`}>
            <Icon />
        </div>
        <div className="min-w-0">
            <div className="text-xs text-gray-500 font-medium truncate">{label}</div>
            <div className="text-sm font-semibold text-gray-800 truncate">{value ?? '—'}</div>
        </div>
    </div>
);

const MODE_DETAIL = "detail";
const MODE_LIST = "list";

const Report = () => {
    const today = new Date().toLocaleDateString("en-CA");

    const [information, setInformation] = useState({});
    const [orders, setOrders] = useState([]);
    const [startDate, setStartDate] = useState(today);
    const [endDate, setEndDate] = useState(today);
    const [maxPageLength, setMaxPageLength] = useState();
    const [pageLength, setPageLength] = useState([]);
    const [categories, setCategories] = useState({});
    const [categoryVoid, setCategorieVoid] = useState({});
    const [loading, setLoading] = useState(false);
    const [sidebarLoading, setSidebarLoading] = useState(false);
    const [error, setError] = useState("");
    const [sidebarError, setSidebarError] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [mode, setMode] = useState(MODE_DETAIL);

    const url = process.env.REACT_APP_BASE_URL;
    const token = localStorage.getItem("token");
    const [selectedOutlet, setSelectedOutlet] = useState("");

    useEffect(() => {
        setPageLength(Array.from({ length: maxPageLength }, (_, i) => i + 1));
    }, [maxPageLength]);

    const fetchReport = async (page = 1) => {
        if (!token || !selectedOutlet) return;
        try {
            setLoading(true);
            setError("");
            setCurrentPage(page);

            if (!startDate) {
                toast.error("Please select a start date");
                return;
            }

            if (!endDate) {
                toast.error("Please select an end date");
                return;
            }

            if (new Date(startDate) > new Date(endDate)) {
                toast.error("Start date cannot be later than end date");
                return;
            }

            const endpoint = mode === MODE_LIST ? "/get-orders-list" : "/report";
            const response = await axios.post(`${url}${endpoint}`, {
                start_date: startDate,
                end_date: endDate,
                outlet_name: selectedOutlet,
                page_no: page,
                token,
            });

            const data = response.data;

            if (mode === MODE_LIST) {
                setOrders(data.data || []);
                if (page === 1) {
                    setInformation(data.summary || {});
                    setMaxPageLength(data.maxPage_Length);
                }
            } else {
                setOrders(data.orders || []);
                if (page === 1) {
                    setInformation(data);
                    setMaxPageLength(data.maxPage_Length);
                }
            }
        } catch (err) {
            setError(
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                "Failed to load report."
            );
            setMaxPageLength(0);
        } finally {
            setLoading(false);
        }
    };

    const handleGenerateReport = () => fetchReport(1);
    const handleNumber = (page) => fetchReport(page);

    const handleSidebar = async () => {
        try {
            setSidebarLoading(true);
            setSidebarError("");
            const response = await axios.post(`${url}/itemstats`, {
                start_date: startDate,
                end_date: endDate,
                outlet_name: selectedOutlet,
                token,
            });
            setCategories(response.data.Completed || []);
            setCategorieVoid(response.data.Void || []);
        } catch (err) {
            setSidebarError(
                err?.response?.data?.message ||
                err?.response?.data?.error ||
                "Failed to load item summary."
            );
        } finally {
            setSidebarLoading(false);
        }
    };

    const handleModeSwitch = (newMode) => {
        if (newMode === mode) return;
        setMode(newMode);
        setOrders([]);
        setInformation({});
        setCurrentPage(1);
        setPageLength([]);
    };

    useEffect(() => {
        if (token && selectedOutlet) fetchReport(1);
    }, [token, selectedOutlet, mode]);

    const { first_orderAt, last_orderAt, Guest_count, Operating_hours, item_count } = information;

    return (
        <div className='flex flex-col min-h-screen'>
            <Navbar />

            <div className="flex-1 flex flex-col lg:flex-row">

                {/* ── LEFT SIDEBAR ── */}
                <aside className="w-1/3 bg-white order-b-0 border-r border-gray-200 p-4 sticky top-0 max-h-[calc(100vh-50px)] overflow-y-auto shadow-sm">
                    <PageStatus loading={loading} error={error} loadingText="Loading summary..." />

                    {!loading && !error && (
                        <>
                            <div className="px-3 py-2.5 border-b border-[#F0EDE8] bg-[#F8F7F3] text-xs font-semibold tracking-[0.15em] uppercase text-[#807e76]">
                                Summary
                            </div>

                            <div className="px-3 py-2.5 overflow-y-auto tiny-scrollbar border-b border-[#F0EDE8]">
                                <KitchenSummaryDetails information={information} />
                            </div>

                            <div className="grid lg:grid-cols-1 xl:grid-cols-2 gap-2 pt-3 px-2.5">
                                <StatCard icon={RiNumbersLine} label="Total Items" value={item_count} iconClass="text-indigo-500" />
                                <StatCard icon={IoFastFoodOutline} label="First Order" value={convertTime(first_orderAt)} iconClass="text-sky-500" />
                                <StatCard icon={IoFastFood} label="Last Order" value={convertTime(last_orderAt)} iconClass="text-orange-500" />
                                <StatCard icon={IoPeopleOutline} label="Guests" value={Guest_count} iconClass="text-violet-500" />
                                <StatCard icon={FcClock} label="Operating Hours" value={Operating_hours} />
                            </div>
                        </>
                    )}
                </aside>

                {/* ── MAIN CONTENT ── */}
                <main className="flex-1 p-3 w-2/3">
                    {/* Filter bar */}
                    <div className="rounded-lg border border-[#E0DDD8] bg-white overflow-hidden mb-3">
                        <div className="p-3 border-b border-[#F0EDE8]">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 xl:flex xl:justify-between xl:items-center text-xs">
                                <div className='max-w-xs text-sm'>
                                    <OutletSearch
                                        selectedOutlet={selectedOutlet}
                                        setSelectedOutlet={setSelectedOutlet}
                                        token={token}
                                    />
                                </div>

                                <div className="flex gap-2 items-center">
                                    <label className="block font-semibold uppercase tracking-wider text-[#807e76]">Start Date</label>
                                    <input
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                        className="border border-[#E0DDD8] px-2 py-1.5 rounded-md bg-[#FAFAF8] text-[#2C2C2A] font-medium w-[120px] cursor-pointer"
                                    />
                                </div>

                                <div className="flex sm:justify-end gap-3 md:gap-2 items-center">
                                    <label className="block font-semibold uppercase tracking-wider text-[#807e76] pr-0.5 sm:pr-0">End Date</label>
                                    <input
                                        type="date"
                                        value={endDate}
                                        onChange={(e) => setEndDate(e.target.value)}
                                        className="border border-[#E0DDD8] px-2 py-1.5 rounded-md bg-[#FAFAF8] text-[#2C2C2A] font-medium w-[120px] cursor-pointer"
                                    />
                                </div>

                                <button
                                    onClick={handleGenerateReport}
                                    className="px-3 py-2 text-xs rounded-md font-medium bg-purple-100 text-purple-800 hover:bg-purple-200 hover:shadow-md"
                                >
                                    View Report
                                </button>

                            </div>
                        </div>

                        <div className='flex justify-between items-center bg-[#FAFAF8] px-3 py-2'>
                            {/* ── Mode toggle ── */}
                            <div className="flex items-center gap-1">
                                <span className="text-xs font-semibold uppercase tracking-wider text-[#807e76] mr-2">View</span>

                                <button
                                    onClick={() => handleModeSwitch(MODE_DETAIL)}
                                    className={`
                                    flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold
                                    border transition-all duration-150
                                    ${mode === MODE_DETAIL
                                            ? "bg-[#2C2C2A] text-[#F8F7F3] border-[#2C2C2A]"
                                            : "bg-white text-[#5A5854] border-[#E0DDD8] hover:bg-[#F3F1EC]"}
                                `}
                                >
                                    {/* grid icon */}
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                        <rect x="0.5" y="0.5" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
                                        <rect x="7.5" y="0.5" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
                                        <rect x="0.5" y="7.5" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
                                        <rect x="7.5" y="7.5" width="5" height="5" rx="1" stroke="currentColor" strokeWidth="1.2" />
                                    </svg>
                                    Detailed
                                </button>

                                <button
                                    onClick={() => handleModeSwitch(MODE_LIST)}
                                    className={`
                                    flex items-center gap-1.5 px-3 py-1.5 rounded-md text-xs font-semibold
                                    border transition-all duration-150
                                    ${mode === MODE_LIST
                                            ? "bg-[#2C2C2A] text-[#F8F7F3] border-[#2C2C2A]"
                                            : "bg-white text-[#5A5854] border-[#E0DDD8] hover:bg-[#F3F1EC]"}
                                `}
                                >
                                    {/* list icon */}
                                    <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                                        <line x1="0.5" y1="2.5" x2="12.5" y2="2.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                                        <line x1="0.5" y1="6.5" x2="12.5" y2="6.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                                        <line x1="0.5" y1="10.5" x2="12.5" y2="10.5" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
                                    </svg>
                                    List
                                </button>
                            </div>

                            <KitchenSummarySidebar
                                handleSidebar={handleSidebar}
                                categories={categories}
                                categoryVoid={categoryVoid}
                                sidebarLoading={sidebarLoading}
                                sidebarError={sidebarError}
                            />
                        </div>
                    </div>

                    <PageStatus loading={loading} error={error} loadingText="Generating report..." />

                    {/* ── View content ── */}
                    {mode === MODE_DETAIL ? (
                        <>
                            <KitchenReportTable
                                loading={loading}
                                error={error}
                                orders={orders}
                                isKitchen={false}
                            />

                            <KitchenReportPagination
                                pageLength={pageLength}
                                currentPage={currentPage}
                                handleNumber={handleNumber}
                            />
                        </>
                    ) : (
                        <KitchenOrderListView
                            loading={loading}
                            error={error}
                            orders={orders}
                            token={token}
                            selectedOutlet={selectedOutlet}
                            isKitchen={false}
                        />
                    )}
                </main>

            </div>

            <Footer />
        </div>
    );
};

export default Report;